import { deviceType } from "@tm/isomorphic-utils";
import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled from "styled-components";

export const CalloutWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 16px;
  padding: 13px 16px 12px 17px;
  background: linear-gradient(${theme.whiteText}, ${theme.whiteText})
      padding-box,
    linear-gradient(90deg, ${theme.redText4}, ${theme.lightRed}) border-box;
  gap: 8px;
  width: 556px;
  height: 48px;
  box-sizing: border-box;

  @media ${deviceType.mobile} {
    width: 100%;
    height: auto;
    padding: 12px;
  }
`;

export const CalloutIcon = styled.img`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

export const CalloutText = styled.span`
  flex: 1;
  font-size: ${fontSize.font12};
  font-weight: ${fontWeight.regular};
  color: ${theme.greyText};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media ${deviceType.mobile} {
    white-space: normal;
  }
`;

export const CalloutCta = styled.button`
  border: none;
  background: none;
  font-size: ${fontSize.font12};
  font-weight: ${fontWeight.bold};
  color: ${theme.blueText};
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  white-space: nowrap;
`;
